import { createFileReader } from './fileReader';

export const handleBase64 = (base64: string, filename: string, type = 'application/pdf'): Promise<void> =>
  fetch(`data:${type};base64,${base64}`)
    .then(res => res.blob())
    .then(blob => handleBlob(blob, filename))
    .catch((error: Error) => {
      throw new Error(
        'Unable to generate Beiblatt-PDF from Backend Response cause: ' + error.message,
      );
    });

function handleBlob(blob: Blob, filename: string): void {
  const base64FileReader = createFileReader();

  // Cypress version for e2e-Test
  if ((window as unknown as Record<string, unknown>)['Cypress']) {
    return;
  }

  // other browser
  base64FileReader.readAsDataURL(blob);

  base64FileReader.onloadend = () => {
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', base64FileReader.result.toString());
    linkElement.setAttribute('download', filename);

    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: false,
    });
    linkElement.dispatchEvent(clickEvent);
  };
}
